import { render } from "./LightStyle.vue?vue&type=template&id=58fd3831"
import script from "./LightStyle.vue?vue&type=script&lang=ts"
export * from "./LightStyle.vue?vue&type=script&lang=ts"
script.render = render

export default script